import React, { useEffect, useState, useRef } from "react";
import "./Journey.css";

const statsData = [
  { value: 500, suffix: "+", label: "Businesses Served Globally" },
  { value: 95, suffix: "%", label: "Customer Satisfaction Rate" },
  { value: 1000, suffix: "+", label: "Successful Projects Completed" },
  {
    value: 7,
    suffix: "+",
    label:
      "Countries Supplied (UAE, Nigeria, Bhutan, Bangladesh, Vietnam, USA, UK, India)",
  },
];

export default function Journey() {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState(statsData.map(() => 0));
  const sectionRef = useRef(null);

  // Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const currentSection = sectionRef.current; // ✅ local variable use

    if (currentSection) observer.observe(currentSection);

    return () => {
      if (currentSection) observer.unobserve(currentSection);
    };
  }, []);

  // Counter Animation
  useEffect(() => {
    if (isVisible) {
      statsData.forEach((stat, index) => {
        let start = 0;
        const end = stat.value;
        const duration = 2000;
        const stepTime = Math.abs(Math.floor(duration / end));

        const timer = setInterval(() => {
          start += 1;
          setCounts((prev) =>
            prev.map((val, i) => (i === index ? start : val))
          );
          if (start === end) clearInterval(timer);
        }, stepTime);
      });
    }
  }, [isVisible]);

  return (
    <section className="journey-section" ref={sectionRef}>
      <div className="journey-header">
        {/* <p className="journey-subtitle">OUR JOURNEY SO FAR</p> */}
        <h2 className="journey-title">Delivering Value Across Borders</h2>
      </div>
   <div className="journey-stats">
  {statsData.map((stat, index) => (
    <div className={`stat-item ${isVisible ? "show" : ""}`} key={index}>
      <h3>
        {counts[index]}
        {stat.suffix}
      </h3>
      <p>{stat.label}</p>
    </div>
  ))}
</div>

    </section>
  );
}
